import { render, staticRenderFns } from "./project-chooser.vue?vue&type=template&id=2376e1b7&scoped=true&"
import script from "./project-chooser.vue?vue&type=script&lang=js&"
export * from "./project-chooser.vue?vue&type=script&lang=js&"
import style0 from "./project-chooser.vue?vue&type=style&index=0&id=2376e1b7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2376e1b7",
  null
  
)

export default component.exports